/**
 * Brand marks for the connector grid.
 *
 * Inline SVG rather than remote images: a settings screen should not make a
 * request to a third party to draw the tile for a service that may not even be
 * enabled, and these render identically offline and behind a strict CSP.
 *
 * Simplified marks in each brand's own colours — enough to be recognised at
 * 28px, which is the entire job of a logo in a connector list.
 */

export function GoogleWorkspaceLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="Google Workspace">
      <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h11.8c-.5 2.7-2.1 5-4.4 6.6v5.5h7.1c4.2-3.8 6.6-9.5 6.6-16.1z" />
      <path fill="#34A853" d="M24 46c6 0 11-2 14.5-5.4l-7.1-5.5c-2 1.3-4.5 2.1-7.4 2.1-5.7 0-10.6-3.9-12.3-9.1H4.3v5.7C7.8 41 15.3 46 24 46z" />
      <path fill="#FBBC05" d="M11.7 28.1c-.4-1.3-.7-2.7-.7-4.1s.3-2.8.7-4.1v-5.7H4.3C2.8 17.1 2 20.4 2 24s.8 6.9 2.3 9.8l7.4-5.7z" />
      <path fill="#EA4335" d="M24 10.8c3.2 0 6.1 1.1 8.4 3.3l6.3-6.3C34.9 4.2 30 2 24 2 15.3 2 7.8 7 4.3 14.2l7.4 5.7c1.7-5.2 6.6-9.1 12.3-9.1z" />
    </svg>
  );
}

export function StripeLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="Stripe">
      <rect width="48" height="48" rx="10" fill="#635BFF" />
      <path
        fill="#FFFFFF"
        d="M23.2 19.4c0-1.1.9-1.6 2.3-1.6 2.1 0 4.7.7 6.8 1.8v-6.4c-2.3-.9-4.6-1.3-6.8-1.3-5.5 0-9.2 2.9-9.2 7.7 0 7.5 10.3 6.3 10.3 9.5 0 1.3-1.1 1.7-2.6 1.7-2.3 0-5.3-1-7.6-2.3v6.5c2.6 1.1 5.2 1.6 7.6 1.6 5.7 0 9.6-2.8 9.6-7.7 0-8.1-10.4-6.6-10.4-9.5z"
      />
    </svg>
  );
}

export function ZoomLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="Zoom">
      <rect width="48" height="48" rx="10" fill="#0B5CFF" />
      <path
        fill="#FFFFFF"
        d="M12 18.6c0-1.4 1.1-2.6 2.6-2.6h11.7c1.4 0 2.6 1.1 2.6 2.6v10.8c0 1.4-1.1 2.6-2.6 2.6H14.6c-1.4 0-2.6-1.1-2.6-2.6V18.6zM30.9 22l4.3-3.4c.7-.6 1.8-.1 1.8.8v9.2c0 .9-1.1 1.4-1.8.8L30.9 26v-4z"
      />
    </svg>
  );
}
